var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    option: true,
    pointer: true,
    selected: !_vm.multiple && _vm.selected,
    focused: _vm.focused,
    'with-detail': _vm.detail !== undefined,
  },on:{"click":_vm.$listeners.click,"mouseenter":_vm.$listeners.hover,"mousedown":function($event){$event.preventDefault();}}},[_c('span',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.detail !== undefined)?_c('span',{staticClass:"detail"},[_vm._v(" "+_vm._s(_vm.detail)+" ")]):_vm._e(),_c('span',{staticClass:"icon"},[(_vm.multiple && _vm.selected)?_c('font-awesome-icon',{attrs:{"icon":"check"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }